/* eslint-disable react/prop-types */
import get from 'lodash/get';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { animateScroll as scroll } from "react-scroll";
import './backtotop.m.css';

function BackToTop({ slug }) {
  const [BackToTop, setbacktotop] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        setbacktotop(true);
      } else {
        setbacktotop(false);
      }
    });
  }, []);

  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 500,
      smooth: 'easeInOutQuint',
      delay: 0
    });
  };

  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 250);
    return () => clearTimeout(timer);
  }, []);

  return slug !== 'budget-2023' ? (
    <div>
      {!initialLoading && (
        <MediaQuery maxWidth={767}>
          <div styleName="back-to-top" style={{ bottom: BackToTop ? '6rem' : '-200px' }}>
            <button styleName="button-container" onClick={scrollToTop}>
              <img src="/images/arrow_up.svg" width="20px" height="16px" styleName="up-arrow" />
              Back to Top
            </button>
          </div>
        </MediaQuery>
      )}
    </div>
  ) : null;
}

const mapStateToProps = state => ({
  slug: get(state, ['qt', 'data', 'section', 'slug'], '')
});

export default connect(mapStateToProps, {})(BackToTop);
